module.exports = __webpack_public_path__ + "static/media/noImg.c6aa2b4a.jpg";